<h2 mat-dialog-title>Selecione a Prioridade</h2>

<mat-dialog-content>
  <p class="priority-description">
    Defina a prioridade do ticket para calcular o SLA automaticamente:
  </p>

  <mat-radio-group [(ngModel)]="priority" class="priority-options">
    <div class="priority-option priority-alta" [class.selected]="priority === 'ALTA'">
      <mat-radio-button value="ALTA" color="warn">
        <div class="priority-label">
          <span class="priority-name">Alta</span>
          <span class="priority-sla">SLA: 7 dias uteis</span>
        </div>
      </mat-radio-button>
    </div>

    <div class="priority-option priority-media" [class.selected]="priority === 'MEDIA'">
      <mat-radio-button value="MEDIA" color="accent">
        <div class="priority-label">
          <span class="priority-name">Media</span>
          <span class="priority-sla">SLA: 15 dias uteis</span>
        </div>
      </mat-radio-button>
    </div>

    <div class="priority-option priority-baixa" [class.selected]="priority === 'BAIXA'">
      <mat-radio-button value="BAIXA" color="primary">
        <div class="priority-label">
          <span class="priority-name">Baixa</span>
          <span class="priority-sla">SLA: 30 dias uteis</span>
        </div>
      </mat-radio-button>
    </div>
  </mat-radio-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button color="warn" (click)="onCancel()">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!priority"
    (click)="onConfirm()">
    Confirmar
  </button>
</mat-dialog-actions>
